import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MeetingNote } from '@models/meeting-notes.model';

export const MeetingNotesActions = createActionGroup({
  source: 'Meeting Notes',
  events: {
    'Load Meeting Notes': emptyProps(),
    'Load Meeting Notes Success': props<{ notes: MeetingNote[] }>(),
    'Load Meeting Notes Failure': props<{ error: string }>(),

    'Upload Meeting Note': props<{
      file: File;
      meetingDescription: string;
      meetingDate: string;
      sendNotification: boolean;
    }>(),
    'Upload Meeting Note Success': props<{ note: MeetingNote }>(),
    'Upload Meeting Note Failure': props<{ error: string }>(),

    'Delete Meeting Note': props<{ id: number }>(),
    'Delete Meeting Note Success': props<{ id: number }>(),
    'Delete Meeting Note Failure': props<{ error: string }>(),

    'View Meeting Note': props<{ id: number; fileName: string }>(),
    'View Meeting Note Success': props<{ blob: Blob; fileName: string }>(),
    'View Meeting Note Failure': props<{ error: string }>(),

    'Download Meeting Note': props<{ id: number; fileName: string }>(),
    'Download Meeting Note Success': props<{ blob: Blob; fileName: string }>(),
    'Download Meeting Note Failure': props<{ error: string }>(),

    'Open Upload Modal': emptyProps(),
    'Close Upload Modal': emptyProps(),
  },
});
